import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import Login from './components/Login';
import CreateProject from './components/CreateProject';
import Register from './components/Register';
import Account from './components/Account';
import PasswordRecovery from './components/PasswordRecovery';
import PasswordReset from './components/PasswordReset';
import Home from './components/Home';
import Dados from './components/Dados';
import Widgets from './components/Widgets';
import Dashboards from './components/Dashboards';
import DashboardsShared from './components/DashboardsShared';
import { Navigate } from 'react-router-dom';

import { ReactComponent as LoginIcon } from './icons/login.svg';
import { ReactComponent as LogoutIcon } from './icons/logout.svg';
import { ReactComponent as ProchildIcon } from './icons/prochild.svg';
import { ReactComponent as FolderIcon } from './icons/folder.svg';
import { ReactComponent as DadosIcon } from './icons/database.svg';
import { ReactComponent as WidgetsIcon } from './icons/widgets.svg';
import { ReactComponent as DashboardsIcon } from './icons/dashboards.svg';
import { ReactComponent as UserIcon } from './icons/user.svg';
import axios from 'axios';

// Automatically log out if token is expired or invalid
axios.interceptors.response.use(
  response => response, // Return normal responses
  error => {
    if (
  error.response?.status === 401 &&
  !window.location.pathname.match(/^\/\d+\/\d+\/[a-zA-Z0-9]+$/) //shared dashboard
) {
      console.log('Token expired or invalid, logging out...');
      localStorage.removeItem('token');
      localStorage.removeItem('selectedProject');
      window.location.href = '/'; // Redirect to login
    }
    return Promise.reject(error);
  }
);


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  // Check user authentication status on component mount
  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token); // Set isLoggedIn based on the token

    const selectedProjectString = localStorage.getItem('selectedProject');
    if (selectedProjectString) {
      try {
        setSelectedProject(JSON.parse(selectedProjectString));
      } catch (error) {
        console.error('Error parsing JSON from localStorage:', error);
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('selectedProject');
    window.location.href = '/';
  };

  return (
    <Router>
      <MainApp isLoggedIn={isLoggedIn} handleLogout={handleLogout} selectedProject={selectedProject} setSelectedProject={setSelectedProject} />
    </Router>
  );
}

const MainApp = ({ isLoggedIn, handleLogout, selectedProject, setSelectedProject }) => {
  const location = useLocation();

  // Function to check if the current path is a shared dashboard route
  const isSharedDashboardPath = location.pathname.match(/^\/\d+\/\d+\/[a-zA-Z0-9]+$/);

  return (
    <div className="container">
      {isLoggedIn && !isSharedDashboardPath && (
        <div className="sidebar">
          <LoginIcon />
          <ul>
            <li>
              <NavLink to="/criar_projeto" className={({ isActive }) => "linkWithIcon" + (isActive ? " active" : "")}>
                <FolderIcon className="smallIcon" />
                Criar projeto
              </NavLink>
            </li>
            <li>
              <NavLink to="/home" className={({ isActive }) => "linkWithIcon" + (isActive ? " active" : "")}>
                <FolderIcon className="smallIcon" />
                Projetos
              </NavLink>
            </li>
            {selectedProject && (
              <>
                <li className="submenu-item">
                  <NavLink to={`/project/${selectedProject.database_id}/dados`} className={({ isActive }) => "linkWithIcon" + (isActive ? " active" : "")}>
                    <DadosIcon className="smallIcon" />
                    Dados
                  </NavLink>
                </li>
                <li className="submenu-item">
                  <NavLink to={`/project/${selectedProject.database_id}/widgets`} className={({ isActive }) => "linkWithIcon" + (isActive ? " active" : "")}>
                    <WidgetsIcon className="smallIcon" />
                    Widgets
                  </NavLink>
                </li>
                <li className="submenu-item">
                  <NavLink to={`/project/${selectedProject.database_id}/dashboards`} className={({ isActive }) => "linkWithIcon" + (isActive ? " active" : "")}>
                    <DashboardsIcon className="smallIcon" />
                    Dashboards
                  </NavLink>
                </li>
              </>
            )}
            <li>
              <NavLink to="/account" className={({ isActive }) => "linkWithIcon" + (isActive ? " active" : "")}>
                <UserIcon className="smallIcon" />
                Utilizador
              </NavLink>
            </li>
            <li>
              <button className="linkWithIcon" onClick={handleLogout}>
                <LogoutIcon className="smallIcon" />
                Logout
              </button>
            </li>
          </ul>
          <ProchildIcon className="prochildIcon" />
        </div>
      )}
      <div className="content">
        <Routes>
          <Route path="/account" element={<Account />} />
          <Route path="/register" element={<Register />} />
          <Route path="/password-recovery" element={<PasswordRecovery />} />
          <Route path="/password-reset/:token" element={<PasswordReset />} />
          <Route
  path="/"
  element={isLoggedIn ? <Navigate to="/home" replace /> : <Login />}
/>
          <Route path="/home" element={<Home setSelectedProject={setSelectedProject} />} />
          <Route path="/criar_projeto" element={<CreateProject />} />
          <Route path="/project/:projectId/dados" element={<Dados />} />
          <Route path="/project/:projectId/widgets" element={<Widgets />} />
          <Route path="/project/:projectId/dashboards" element={<Dashboards />} />
          <Route path="/:projectId/:dashboardId/:sharecode" element={<DashboardsShared />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
